export default theme => ({
  iconLinks: {
    marginBottom: theme.spacing.unit
  },
  iconLink: {
    display: 'inline-block',
    width: 30,
    height: 30,
    '&:not(:last-child)': {
      marginRight: theme.spacing.unit
    },
    '& > svg': {
      fill: 'none',
      stroke: '#fff',
      strokeWidth: 1.5,
      transition: {
        property: 'stroke',
        duration: theme.transitions.duration.short,
        function: theme.transitions.easing.easeIn
      }
    },
    '&:hover': {
      '& > svg': {
        stroke: '#6bfcc1'
      }
    }
  },
  textLinks: {
    marginBottom: theme.spacing.unit
  },
  textLink: {
    fontWeight: 600,
    color: '#fff',
    transition: {
      property: 'color',
      duration: theme.transitions.duration.short,
      timingFunction: theme.transitions.easing.easeIn
    },
    '&:hover': {
      color: '#6bfcc1'
    },
    '&:not(:last-child)': {
      marginRight: theme.spacing.unit * 2
    }
  },
  appStoreLink: {
    display: 'inline-block',
    width: 150,
    '& > svg': {
      fill: '#fff',
      transition: {
        property: 'fill',
        duration: theme.transitions.duration.short,
        timingFunction: theme.transitions.easing.easeIn
      }
    },
    '&:hover': {
      '& > svg': {
        fill: '#6bfcc1'
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/Footer/Menu/styles.js